<ul *ngIf="messages && messages.length > 0" class="container">
    <li *ngFor="let message of messages" class="message">
      {{ message }}
    </li>
</ul>
